import { SearchX } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'
import { MangoButton } from '~/components/shared/MangoButton'

import { spacing } from '../constants/theme'
import { Text } from './core'
import { FontStyle } from './core/Text'

const EmptyStateWrapper = styled.div`
  height: 100%;
  width: 100%;
  padding: 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`

const TitleWrapper = styled.div`
  margin-top: ${spacing.spacingXXXL};
  text-align: center;
  font-weight: bold;
`

const SubtitleWrapper = styled.div`
  margin-bottom: 48px;
  margin-top: ${spacing.spacingSM};
`

interface EmptyStateProps {
  title?: string
  subtitle?: string
  subtitle2?: string
  buttonText?: string
  onClick?: () => void
  icon?: boolean
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title = '',
  subtitle = '',
  subtitle2 = '',
  buttonText = '',
  onClick,
  icon = true,
}) => (
  <EmptyStateWrapper>
    {icon && <SearchX size={48} color="var(--chakra-colors-fg-muted)" />}
    <TitleWrapper>
      {title && (
        <Text
          fontStyle={FontStyle.Medium}
          align="center"
          weight="bold"
          color="var(--chakra-colors-fg-muted)"
          text={title}
        />
      )}
    </TitleWrapper>
    <SubtitleWrapper>
      <Text
        text={subtitle}
        fontStyle={FontStyle.Normal}
        align="center"
        weight="normal"
        color="var(--chakra-colors-fg-muted)"
      />
    </SubtitleWrapper>
    {subtitle2 && (
      <SubtitleWrapper>
        <Text
          text={subtitle2}
          fontStyle={FontStyle.Normal}
          align="center"
          weight="normal"
          color="var(--chakra-colors-fg-muted)"
        />
      </SubtitleWrapper>
    )}

    {onClick && <MangoButton onClick={onClick}>{buttonText}</MangoButton>}
  </EmptyStateWrapper>
)

export { EmptyState }
